import { useRef } from 'react'
import { useIdleTimer } from 'react-idle-timer'
import { useNavigate } from 'react-router-dom'
import { useLazyQuery } from '@apollo/client'
import moment from 'moment'
import client from '../client'
import config from '../config'
import { ME_QUERY } from '../graphql/queries'
import { getExpiry, getToken, getUid, getClient, clearUserData, setTimer, setUser } from './helper'

const TimeOut = () => {
  const navigate = useNavigate()
  const timeOutRef = useRef(null)

  const storeUser = data => {
    setUser(data.me)
  }

  const [fetchNewRefreshToken] = useLazyQuery(ME_QUERY, {
    fetchPolicy: 'network-only',
    onCompleted: storeUser,
    onError: () => {
      setTimer(
        JSON.stringify({
          last_expiry: moment.unix(getExpiry()).toLocaleString(),
          date: moment().toLocaleString(),
          message: 'logged out by me_query',
        })
      )
      console.debug('logged out by me_query')
      logout()
    },
  })

  const getTimeLeft = () => moment.unix(getExpiry()).diff(moment())

  const logout = () => {
    fetch(`${config.apollo.baseUrl}/auth/sign_out`, {
      method: 'GET',
      headers: {
        'access-token': getToken(),
        uid: getUid(),
        client: getClient(),
      },
    })
      .then(() => {
        clearUserData(client)
        navigate('/logout')
      })
      .catch(() => {
        clearUserData(client)
        navigate('/logout')
      })
  }

  const handleOnIdle = () => {
    console.debug('idle')
    timeOutRef.current = setTimeout(() => {
      logout()
      console.debug('timed out')
      setTimer(
        JSON.stringify({
          last_expiry: moment.unix(getExpiry()).toLocaleString(),
          date: moment().toLocaleString(),
          message: 'loggout by setTimeout',
        })
      )
      console.debug('logging out')
    }, getTimeLeft() - 10000)
  }
  const handleActive = () => {
    console.debug('active')
    if (timeOutRef?.current) {
      clearTimeout(timeOutRef.current)
      console.debug('cleanup')
    }
    if (getTimeLeft() < 10000) {
      setTimer(
        JSON.stringify({
          last_expiry: moment.unix(getExpiry()).toLocaleString(),
          date: moment().toLocaleString(),
          message: 'logout by handleActive',
        })
      )
      console.debug('logging out by handleActive')
      logout()
    }
  }
  const handleOnAction = event => {
    if (event.type === 'mousedown' || event.type === 'keydown') {
      console.debug(event.type)
      fetchNewRefreshToken({
        onCompleted: storeUser,
      })
    }
  }

  useIdleTimer({
    timeout: 1000 * 3,
    onIdle: handleOnIdle,
    onAction: handleOnAction,
    onActive: handleActive,
    debounce: 2000,
  })
  return null
}

export default TimeOut
